import { render, staticRenderFns } from "./PartCkuStts.vue?vue&type=template&id=5db1c5d6&"
import script from "./PartCkuStts.vue?vue&type=script&lang=js&"
export * from "./PartCkuStts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports